/**
 * Xếp ca cho người MỚI ở Cấu hình → Nhân viên (kế hoạch san-sang-thi-truong-2026-10, hạng mục 1.4).
 * Hàm thuần, có test (`xep-ca-nguoi-moi.test.ts`).
 */
import { CAC_THU, type GioLamMayChu } from './gio-lam.ts'

export interface CaMotNgay {
  tu: number
  den: number
  lam: boolean
}

/** Ca mặc định khi chi nhánh chưa có giờ mở cửa nào: đúng mặc định cũ của form (T2–T7, 09:00–20:00). */
const GIO_MAC_DINH = { mo: 540, dong: 1200 } as const

/**
 * Ca mặc định của người mới = giờ mở cửa của chi nhánh họ làm: ngày nào chi nhánh mở thì có ca, ngày nghỉ thì
 * không. Ngày có nhiều khoảng (nghỉ trưa) lấy từ lúc mở đầu tới lúc đóng cuối — chủ tiệm chỉnh tiếp nếu cần.
 *
 * Trước đây cứng `lam: t <= 6` trong khi chi nhánh mới mở 7 ngày → Chủ nhật "mở cửa mà không ai làm" (thẩm
 * định 10/10). Chưa có giờ mở cửa nào thì giữ mặc định cũ.
 */
export function caMacDinhTuGioLam(gioLam: GioLamMayChu[]): Record<number, CaMotNgay> {
  const ca: Record<number, CaMotNgay> = {}
  const coGio = gioLam.length > 0
  for (const t of CAC_THU) {
    const trongNgay = gioLam.filter((g) => g.thu === t)
    if (!coGio) {
      ca[t] = { tu: GIO_MAC_DINH.mo, den: GIO_MAC_DINH.dong, lam: t <= 6 }
    } else if (trongNgay.length === 0) {
      ca[t] = { tu: GIO_MAC_DINH.mo, den: GIO_MAC_DINH.dong, lam: false }
    } else {
      ca[t] = {
        tu: Math.min(...trongNgay.map((g) => g.moMin)),
        den: Math.max(...trongNgay.map((g) => g.dongMin)),
        lam: true,
      }
    }
  }
  return ca
}

/**
 * Người nhận khách cần ca, mà ca phải thuộc một chi nhánh. Tiệm chưa có chi nhánh thì KHÔNG lưu im lặng (trước
 * đây người được lưu nhưng bỏ qua bước xếp ca, không báo) — dẫn chủ tiệm sang tạo chi nhánh trước.
 */
export function canTaoChiNhanhTruoc(input: { nhanKhach: boolean; soChiNhanh: number }): boolean {
  return input.nhanKhach && input.soChiNhanh === 0
}
